import {FormControl, InputLabel, MenuItem, Select, TextField} from '@material-ui/core';
import {
  CompleteInequalityRange,
  IncompleteInequalityRange,
  InequalityRange,
  isValidInequalityRange,
} from 'Core/models/InequalityRange';
import * as O from 'fp-ts/lib/Option';
import React, {useEffect, useState} from 'react';
import {withEventValue} from 'Shared/utilities/WithEventValue';
import './InequalityFilter.sass';

type InequalityFilterProps = {
  inequalityRange: O.Option<InequalityRange>;
  onChange: (value: O.Option<CompleteInequalityRange>) => any;
};

const InequalityFilterOptions = [
  {name: 'None', value: '0'},
  {name: 'Equal To', value: '1'},
  {name: 'Greater Than', value: '2'},
  {name: 'Less Than', value: '3'},
];

const InequalityFilter = (props: InequalityFilterProps) => {
  const [inequalityRange, setInequalityRange] = useState(
    O.getOrElse((): InequalityRange => new IncompleteInequalityRange('', ''))(props.inequalityRange)
  );

  useEffect(() => {
    if (isValidInequalityRange(inequalityRange)) {
      props.onChange(O.some(inequalityRange));
    }
  }, [inequalityRange]);

  const setInputState = (value: string) => {
    setInequalityRange(prevState => CompleteInequalityRange.create(prevState.operator, value));
  };

  const setDropdownState = (value: string) => {
    setInequalityRange(prevState => CompleteInequalityRange.create(value, prevState.operand));
  };

  return (
    <FormControl>
      <div className="inequality-filter">
        <div>
          <InputLabel htmlFor="select-inequality">Select One</InputLabel>
          <Select
            title="Select"
            onChange={e => setDropdownState(e.target.value ? String(e.target.value) : '')}
            className="inequality-filter__input"
            value={inequalityRange.operator}
            name="select-inequality"
          >
            {InequalityFilterOptions.map((item, index) => {
              return (
                <MenuItem key={`inequality-${index}`} value={item.value}>
                  {item.name}
                </MenuItem>
              );
            })}
          </Select>
        </div>
        <div>
          <TextField
            type="number"
            title="Enter value"
            placeholder="Enter value"
            className="inequality-filter__input"
            onChange={withEventValue(setInputState)}
            value={inequalityRange.operator === '0' ? '' : inequalityRange.operand}
            disabled={inequalityRange.operator === '0' ? true : false}
          />
        </div>
      </div>
    </FormControl>
  );
};

export default InequalityFilter;
